exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-member .ant-modal-footer {\n  display: none;\n}\n.ant-form-item-control-wrapper {\n  width: 97%;\n}\n.has-error .ant-form-explain {\n  margin-left: 43px;\n}\n.ant-form-item-control {\n  line-height: 1.3;\n}\n#number_fld.has-error .ant-form-explain {\n  margin-left: 0 !important;\n}\n#sndnumber_fld.has-error .ant-form-explain {\n  margin-left: 0 !important;\n}\n@media screen and (min-width: 320px) and (max-width: 767px) {\n.add-member .ant-modal-content {\n    height: 75vh;\n    overflow: auto;\n}\n}\n", ""]);

// exports
